@if (cartIsLoading) {
  <dcp-loading-page/>
} @else {
  @if (!hideReviewSubmitContent) {
    <div class="udex-grid udex-mx-auto udex-pb-56 udex-pb-lg-84">
      <div class="row">
        <dcp-navigation-to class="udex-pt-24 udex-mb-32 udex-ps-0"></dcp-navigation-to>
      </div>

      <div class="row px-sm-0">
        <div class="col-12 col-lg-8">
          <div
            [class.udex-mb-32]="!!(dcpGlobalMessageService.getMessagesDisplayed$() | async)">
            <dcp-disposable-message></dcp-disposable-message>
          </div>

          @if (orderHistoryProcessingErrorService.orderHistoryProcessingError$ | async) {
            <dcp-order-history-processing-error
              class="d-block">
            </dcp-order-history-processing-error>
          }

          @if (showCartHeaderSection && addresses.length) {
            <dcp-cart-header-information
              [isCurrentUserIndividual]="isCurrentUserIndividual"
              [addresses]="addresses"
              [paymentType]="paymentType"
              [documents]="documents"
              [cartIsLoading]="cartIsLoading">
            </dcp-cart-header-information>
          }

          @if (cartEntryGroups?.length) {
            <dcp-bundle-provided-by
              [entryGroups]="cartEntryGroups"
              [orderEntries$]="cartEntries$"
              [displayTitle]="false">
              <ng-template #derivatives let-context>
                <dcp-additional-required-solutions-button
                  [derivativeCount]="context.derivativeCount"
                  [providerContract]="context.providerContract">
                </dcp-additional-required-solutions-button>
              </ng-template>
              <ng-template #groupTotal let-context>
                <dcp-group-total
                  [showDivider]="false"
                  [checkout$]="cart$"
                  [providerContract]="context.providerContract">
                </dcp-group-total>
              </ng-template>
              <ng-template #recurringTotal let-context>
                <dcp-recurring-total
                  [checkout$]="cart$"
                  [providerContract]="context.providerContract">

                </dcp-recurring-total>
              </ng-template>
              <ng-template #termsAndConditions let-context>
                <dcp-terms-conditions
                  [removalStatus]="context.removalStatus"
                  [entry]="context.entry"
                  [entries]="context.entries">
                </dcp-terms-conditions>
              </ng-template>
              <ng-template #payment let-context>
                @if (showPaymentAccordion(context.entry) | async) {
                  <dcp-checkout-payments
                    [entry]="context.entry"
                    [providerContract]="context.providerContract"
                    [componentTexts]="componentTexts"
                    [paymentModes]="paymentModes"
                    [expandAll]="context.entryCount === 1">
                  </dcp-checkout-payments>
                }
              </ng-template>
              <ng-template #providedOrderEntries let-context>
                <dcp-bundle-order-table
                  [entry]="context.entry"
                  [isInvalid]="context.isInvalid"
                  [collapsable]="context.collapsable"
                  [collapsed]="context.collapsed"
                  [showPrice]="true"
                  [showEditAction]="false"
                  [showRemoveAction]="showRemoveAction">
                </dcp-bundle-order-table>
              </ng-template>
            </dcp-bundle-provided-by>
          }
        </div>

        <div class="col-12 col-lg-4">
          <dcp-summary
            [componentTexts]="componentTexts"
            [entries]="cartEntries$ | async"
            [selectedView]="view.CheckOut"
            [ngClass]="!showCartHeaderSection && !isVisibleDisposableBlock ? 'sticky-order-summary-margin-top' : ''">
          </dcp-summary>
        </div>
      </div>
    </div>

    @if (cart$ | async; as cart) {
      <dcp-invalid-cart-entry-message
        [cart]="cart">
      </dcp-invalid-cart-entry-message>
    }
  }

  <dcp-configure-service-error
    (configureServiceError)="hideReviewSubmitContent = $event">
  </dcp-configure-service-error>
}
